import axios from "axios";

export default {
    namespaced: true,
    state: {
        suppliers:[],
        supplier_info:{}
    },
    getters:{
        suppliers(state){
            return state.suppliers
        },
        supplier_info(state){
            return state.supplier_info
        }
    },  
    mutations:{
        SET_SUPPLIER_LIST (state, payload) {
            state.suppliers = payload
        },
        SET_SUPPLIER_INFO (state, payload) {
            state.supplier_info = payload
        }
    },
    actions:{
       async getActiveSupplierList(context,param){
        const response = await axios.get('/api/suppliers',{
            headers:{
              'Authorization':`Bearer ${param.token}`,
              "Access-Control-Allow-Headers": "*",
               "Access-Control-Allow-Method" : "*",
               "Access-Control-Allow-Origin": "*",
               "Access-Control-Allow-Credentials": "*",
            }
          });

            if(response.status == 200){

                context.commit('SET_SUPPLIER_LIST',response.data.data)
            }
       }
    }
}